import React, { useContext } from "react";
import { Link } from "react-router-dom";

import Modal from "@mui/material/Modal";
import Rating from "../../../../../components/Rating";
import { ManageLoadPostDetailPageContext } from "../../";

const OfferDetailsModal = () => {
  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );

  const closeModal = () =>
    loadPostDetailContextDispatch({
      type: "CLOSE_OFFER_DETAILS_MODAL",
    });

  const offer = loadPostDetailState.offerDetailModal?.modalData;

  return (
    <Modal
      open={loadPostDetailState.offerDetailModal?.status}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="mui-customized"
    >
      <div className="container">
        <div className="col-lg-8 mx-auto">
          <div className="view-all-load-modal">
            <button className="close-modal-icon" onClick={closeModal}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className="loader-user-info mb-5">
              <div className="loader-user-img">
                <img src={offer?.carrier?.profile_picture} alt="" />
              </div>

              <div>
                <h1 className="large-text">{offer?.carrier?.username}</h1>
                <div className="user-rating">
                  {!["", null, undefined].includes(
                    offer?.carrier?.avg_rating
                  ) && <Rating rating={offer?.carrier?.avg_rating} />}
                  <span>({offer?.carrier?.avg_rating})</span>
                </div>
                <span className="post-date">{offer?.created_date}</span>
              </div>
            </div>

            <div className="user-extra-info">
              <div className="user-extra-info-box">
                <span>Offer Amount :</span>
                <span>$ {offer?.amount}</span>
              </div>
              <div className="user-extra-info-box">
                <span>Counter Offer:</span>
                <span>
                  {" "}
                  {!["", null, undefined].includes(offer?.counter_amount)
                    ? offer?.counter_amount
                    : "- - -"}
                </span>
              </div>
              <div className="user-extra-info-box">
                <span>Fixed Offer:</span>
                <span>
                  {offer?.is_counter_amount_fixed ? (
                    <i className="fa-solid fa-check"></i>
                  ) : (
                    <i className="fa-solid fa-xmark"></i>
                  )}
                </span>
              </div>
              <div className="user-extra-info-box">
                <span>Pickup Datetime:</span>
                <span>{offer?.pickup_time_formate}</span>
              </div>
              <div className="user-extra-info-box">
                <span>Estimated Duration Of Delivery: </span>
                <span>{offer?.estimated_delivery_time}</span>
              </div>
              <div className="user-extra-info-box d-block">
                <span>Description</span>
                <br />
                <span>{offer?.description}</span>
              </div>

              <Link
                to={`/${offer?.carrier?.id}/user-profile-information/`}
                className="view-all-loads-btn"
              >
                View Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(OfferDetailsModal);
